import { render, staticRenderFns } from "./SellerPayment.vue?vue&type=template&id=9dc50468&"
import script from "./SellerPayment.vue?vue&type=script&lang=js&"
export * from "./SellerPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports